import { Component } from "react";
import "./PageWithHeaderFooter.css";

export default class PageWithHeaderFooter extends Component {
  render() {
    const className =
      "PageWithHeaderFooter" + (this.props.className ? " " + this.props.className : "");
    return (
      <div className={className}>
        {this.props.header}
        {this.props.children}
        {this.props.footer}
      </div>
    );
  }
}
